import { Tap } from '@/shared/ui/Tap'
import { FilterIcon } from '@/shared/ui/icons/FilterIcon'
import type { CommonCode } from '@/shared/lib/apiTypes'

export function CategoryTabBar({
  groups,
  selected,
  onSelect,
  hasFilter,
  filterOpen,
  onOpenFilter,
}: {
  groups: CommonCode[]
  selected: string | null
  onSelect: (code: string | null) => void
  hasFilter: boolean
  filterOpen: boolean
  onOpenFilter: () => void
}) {
  return (
    <div className="relative sticky top-[var(--sticky-top,0px)] z-20 before:absolute before:inset-y-0 before:left-1/2 before:-z-10 before:w-screen before:-translate-x-1/2 before:bg-white-50 flex min-h-[42px] items-center gap-2 py-2">
      <button
        type="button"
        className={
          hasFilter
            ? 'ui-pressable ui-pressable--circle inline-flex h-[38px] w-[38px] shrink-0 cursor-pointer items-center justify-center rounded-[99px] border-0 bg-violet-500 p-0 text-violet-50'
            : 'ui-pressable ui-pressable--circle inline-flex h-[38px] w-[38px] shrink-0 cursor-pointer items-center justify-center rounded-[99px] border-0 bg-violet-50 p-0 text-black-200'
        }
        aria-label="필터"
        aria-expanded={filterOpen}
        onClick={onOpenFilter}
      >
        <FilterIcon />
      </button>
      <div className="flex flex-wrap gap-2" role="group" aria-label="분야">
        <Tap selected={selected === null && !hasFilter} onClick={() => onSelect(null)}>
          전체
        </Tap>
        {groups.map((g) => (
          <Tap
            key={g.code}
            selected={selected === g.code && !hasFilter}
            onClick={() => onSelect(g.code)}
          >
            {g.label}
          </Tap>
        ))}
      </div>
    </div>
  )
}
